(function () {
  function getHeaderOffset() {
    const header =
      document.querySelector('.header-wrapper--isolated-product.shopify-section-header-sticky:not(.shopify-section-header-hidden)') ||
      document.querySelector('.header-wrapper--isolated-product');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function scrollToTarget(target) {
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 8;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-isolated-nav-link]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    event.preventDefault();
    scrollToTarget(target);

    const drawer = link.closest('header-drawer');
    if (drawer) {
      const details = drawer.querySelector('details');
      if (details?.open) details.open = false;
    }
  });
})();
